import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
export default class BlogCategories extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.blogCategories = app.forum.attribute('blogTags');
  }
  view() {
    return m("div", {
      className: "BlogCategories BlogSideWidget"
    }, m("h3", null, app.translator.trans('v17development-flarum-blog.forum.categories')), this.blogCategories && this.blogCategories.map(tagId => {
      const tag = app.store.getById('tags', tagId);
      if (!tag) return null;
      const tags = [];
      let showSubTags = this.blogCategories.length === 1 || tag.slug() === m.route.param('slug');

      // Add tags
      app.store.all('tags').forEach(_tag => {
        if (_tag.isChild() && _tag.parent() === tag) {
          if (_tag.slug() === m.route.param('slug')) {
            showSubTags = true;
          }
          tags.push(this.categoryItem(_tag));
        }
      });
      return showSubTags ? [this.categoryItem(tag), ...tags] : this.categoryItem(tag);
    }));
  }

  // Category item
  categoryItem(tag) {
    return m(Link, {
      href: app.route('blogCategory', {
        slug: tag.slug()
      }),
      force: true,
      className: "BlogSideWidget-item BlogSideWidget-item-".concat(tag.id(), " ").concat(tag.isChild() && app.forum.attribute('blogCategoryHierarchy') == true ? 'BlogSideWidget-item-child' : '')
    }, m("span", {
      className: tag.icon() === '' ? 'BlogSideWidget-item-colored' : '',
      style: {
        backgroundColor: tag.icon() === '' ? tag.color() : null
      }
    }, m("i", {
      className: tag.icon()
    })), tag.name());
  }
}
flarum.reg.add('v17development-blog', 'forum/components/BlogCategories', BlogCategories);